import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'dateMsg' })
export class DateTimePipe implements PipeTransform {
  transform(value: Date) {
    if (!(value instanceof Date)) value = new Date(value);

    let seconds: number = Math.floor(
      (new Date().getTime() - value.getTime()) / 1000
    );

    let interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return moment(value).format('HH:mm DD-MM-YYYY');
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return moment(value).format('HH:mm');
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return moment(value).format('HH:mm');
    }
    return moment(value).format('HH:mm');
  }
}
